module.exports = __webpack_public_path__ + "img/scene-tea.35c9f53c.png";